@if (crumbs.length > 0) {
<nav class="breadcrumb" aria-label="Breadcrumb">
  <ol class="breadcrumb__list">
    @for (crumb of crumbs; track $index) {
      <li class="breadcrumb__item">
        @if (!$first) {
          <span class="breadcrumb__sep" aria-hidden="true">/</span>
        }
        @if (crumb.current) {
          <span class="breadcrumb__crumb breadcrumb__crumb--current" aria-current="page">
            @if (crumb.icon) {
              <i class="breadcrumb__icon {{ crumb.icon }}" aria-hidden="true"></i>
            }
            @if (crumb.label) { <span>{{ crumb.label }}</span> }
          </span>
        } @else {
          <a class="breadcrumb__crumb breadcrumb__link" [routerLink]="crumb.link">
            @if (crumb.icon) {
              <i class="breadcrumb__icon {{ crumb.icon }}" aria-hidden="true"></i>
            }
            @if (crumb.label) { <span>{{ crumb.label }}</span> }
          </a>
        }
      </li>
    }
  </ol>
</nav>
}
